import ReactionButton from 'components/atoms/reactionButton';
import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ReactionViewProps {
  isShown: boolean;
  onPressReaction: (reaction: string) => void;
  onPressRaiseHand: () => void;
}

const ReactionView = (props: ReactionViewProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const reactions = ['👍', '👏', '❤️', '😂', '😮', '🎉'];

  const RaiseHandView = (
    <TouchableOpacity
      style={styles.raiseHandView}
      onPress={props.onPressRaiseHand}>
      <Text style={styles.raiseHandViewText}>
        {strings.conferenceScreen.reactions.raiseHand}
      </Text>
    </TouchableOpacity>
  );

  const ReactionsView = (
    <View style={styles.reactionsContainer}>
      {reactions.map(item => {
        return (
          <ReactionButton
            key={item}
            reaction={item}
            onPress={() => props.onPressReaction(item)}
          />
        );
      })}
    </View>
  );

  return props.isShown ? (
    <View style={styles.container}>
      {RaiseHandView}
      {ReactionsView}
    </View>
  ) : (
    <></>
  );
};

export default ReactionView;
